export function injectDurations(sections,done) {
    sections.map((section,index)=>{
        var totalDuration = 0;
        var lessons = 0;
        section.lectures.map((lecture,key)=>{
            lessons += 1
            var video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = function() {
                lecture.duration = Math.floor(video.duration);
                totalDuration +=   Math.floor(video.duration);
                section.duration =totalDuration;
                section.lessons= lessons;
                section.position = index
                lecture.position = key
                console.log(totalDuration,'duration')
                if(index === (sections.length-1) && (section.lectures.length-1===key)) done()
            }
            video.src = lecture.video;
        })
    })
    
}

export default injectDurations